import { useText } from '../i18n.js'

/**
 * Der Weg aus der Vorführung heraus.
 *
 * Bis hierher war die Vorführung eine Einbahnstraße: Wer sie überzeugt hat,
 * fand keinen Knopf und musste die Adresse von Hand zurücktippen. Die Leiste
 * schließt genau diese Lücke — und nur sie: Sie zeigt sich ausschließlich auf
 * dem Vorführ-Board (`isShowcaseVisit`), niemals einem Gast, den ein Kunde
 * eingeladen hat. Ein Werbebalken in einem fremden Kundenvortrag wäre das
 * Gegenteil dessen, wofür der Wartebildschirm den Auftritt der Organisation
 * trägt.
 *
 * Sie sitzt oben statt unten: Unten liegen im Vortrag die Sprechernotizen und
 * die Folgeleiste, und der Vortrag selbst ist unten breiter.
 */
export function ShowcaseBar(): React.ReactElement {
  const t = useText()

  return (
    <div className="showcase-bar">
      <span className="showcase-bar-text">{t('showcase.bar.text')}</span>
      <span className="showcase-bar-actions">
        {/*
          Volle Seitenwechsel statt `Link`: Beide Ziele legen serverseitig etwas
          an und verlassen die Gastsitzung. Ein Wechsel innerhalb der laufenden
          Ansicht ließe die WebSocket-Verbindung zur Vorführung offen.
        */}
        <a className="button primary" href="/demo">
          {t('showcase.bar.try')}
        </a>
        <a className="button ghost" href="/de/">
          {t('showcase.bar.about')}
        </a>
      </span>
    </div>
  )
}
